import {combineReducers} from "redux";
import {machineReducer} from './Machine/reducers';
import clientReducer from './Client/reducers';
import authReducer from "./auth/reducers";
import UserReducer from "./User/reducers";
import EventReducer from "./Event/reducers";
import SessionReducer from "./Session/reducers";
import {configurationReducer} from "./Configuration/reducers";
import configReducer from './Config/reducers';
import capabilitiesReducer from './Capabilities/reducers';
import resourcesReducer from './resources/reducers';
import {rolesReducer} from './Roles/reducers';
import {overridesReducer} from './Overrides/reducers';
import {companiesReducer} from './Company/reducers';
import {countriesReducer} from './Country/reducers';

export default combineReducers({
    auth: authReducer,
    machines:machineReducer,
    clients:clientReducer,
    Users:UserReducer,
    events:EventReducer,
    sessions:SessionReducer,
    configurations:configurationReducer,
    newconfig:configReducer,
    capabilities:capabilitiesReducer,
    resources:resourcesReducer,
    roles:rolesReducer,
    overrides:overridesReducer,
    companies:companiesReducer,
    countries:countriesReducer,
});